import * as React from 'react';
import PropsChecker from '@core-front/props-checker';
export const ModalContext = React.createContext({
    isClosable: true,
    isOpen: false,
    open: /* istanbul ignore next */ () => null,
    close: () => null,
    trigger: null,
    triggerRef: /* istanbul ignore next */ () => null,
});
const ModalProviderCore = (props) => {
    return (React.createElement(PropsChecker, { componentName: "ModalProvider", componentProps: props, defaultValueName: "defaultIsOpen", valueName: "isOpen", onChangeNames: "onToggle", onChangeAltNames: ['onOpen', 'onClose'] },
        React.createElement(ModalProviderCoreInner, Object.assign({}, props))));
};
export default ModalProviderCore;
export class ModalProviderCoreInner extends React.Component {
    constructor(props) {
        super(props);
        this.openModal = () => {
            if (typeof this.props.isOpen === 'undefined') {
                this.setState({
                    isOpen: true,
                });
            }
            if (this.props.onToggle) {
                this.props.onToggle(true);
            }
            if (this.props.onOpen) {
                this.props.onOpen();
            }
        };
        this.closeModal = (event, childOnClick) => {
            if (typeof this.props.isOpen === 'undefined') {
                this.setState({
                    isOpen: false,
                });
            }
            if (this.props.onToggle) {
                this.props.onToggle(false);
            }
            if (this.props.onClose) {
                this.props.onClose();
            }
            if (childOnClick) {
                childOnClick(event);
            }
        };
        this.setTrigger = (trigger) => {
            this.setState({
                trigger,
            });
        };
        this.state = {
            isOpen: this.props.defaultIsOpen || false,
            trigger: null,
        };
    }
    get isOpen() {
        return (this.props.onToggle || (this.props.onOpen && this.props.onClose)) && typeof this.props.isOpen !== 'undefined'
            ? this.props.isOpen
            : this.state.isOpen;
    }
    renderContent() {
        const { HashTrigger } = this.props.components;
        return this.props.id ? (React.createElement(HashTrigger, { id: this.props.id, onMatch: this.openModal, scrollOnMatch: false, renderWrapper: false }, this.props.children)) : (React.createElement(React.Fragment, null, this.props.children));
    }
    render() {
        const modalContextValue = {
            close: this.closeModal,
            id: this.props.id,
            isClosable: this.props.isClosable,
            isOpen: this.isOpen,
            open: this.openModal,
            trigger: this.state.trigger,
            triggerRef: this.setTrigger,
        };
        return React.createElement(ModalContext.Provider, { value: modalContextValue }, this.renderContent());
    }
}
ModalProviderCoreInner.defaultProps = {
    isClosable: true,
};
